//@ts-ignore
import { EnsureUser } from "components/auth/EnsureUser";
//@ts-ignore
import { UcTabStrip } from '../../common/UcTabStrip';
//@ts-ignore
import { UcMobileNavPage } from '../../common/UcMobileNavPage';
import { PageContext, PageState, PageAction } from "lib/PageProvider";
import { useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
//@ts-ignore
import { useResponsive } from 'lib/useResponsive';
//@ts-ignore
import { useStatefulParam } from 'lib/useStatefulParam';
//@ts-ignore
import { UcWidget } from '../../common/obsolete/UcWidget';
import { useTheme } from '@mui/material/styles';
import { PaymentusListPage } from "./PaymentusListPage";

export const PaymentsPage = () => {
    const { t } = useTranslation();
    const { isMobile } = useResponsive();
    const statefulParam = useStatefulParam({paramName: "paymentsNav_link", paramValue: 'Paymentus'});
    const [pageState, pageDispatch] = useContext<[PageState, React.Dispatch<PageAction>]>(PageContext);
    const params = new URLSearchParams(window.location.search);
    const theme = useTheme();

    const views = useMemo(() => {
        const commonViews = [
            {
                title: t("Paymentus"),
                subtitle: t("Information and set up Paymentus features"),
                tabRender: <div>{t("Paymentus")}</div>,
                contentRender: <PaymentusListPage />
            }
        ];

        return commonViews;
        
    }, [t]);

    useEffect(() => {
        pageDispatch({
            header: t("Payments"),
            actionItems: [] as any[],
            variableHeader: "",
            tabs: views,
            onTabChange: () => { },
            tabValue: ''
        });
    }, [pageState.header, pageDispatch, t, views]);

    console.log("PaymentsPage - Loaded");
    return (
        <EnsureUser>
            { isMobile && (
                <UcMobileNavPage
                    pageTitle={t("Payments")}
                    onChange={statefulParam.onSetValue}
                    views={views}
                    value={params.get("paymentsNav_link") !== null ? statefulParam.value : 0}
                    contentBackgroundColor={theme.palette.background.default}
                />
            )}
            { !isMobile && statefulParam.isRenderReady && (
                <UcWidget contentPadding={0}>
                    <UcTabStrip
                        onChange={statefulParam.onSetValue}
                        showInMenu={true}
                        tabs={views}
                        value={statefulParam.value}
                    />
                </UcWidget>
            )}
        </EnsureUser>
    );
}